import type { TypedSupabaseClient } from "./supabase";

export type UsageEventType = "ai_usage" | "storage" | "error";

export interface UsageEventInput {
  eventType: UsageEventType;
  action: string;
  domain?: string | null;
  storageDeltaBytes?: number | null;
  errorCode?: string | null;
  requestId?: string | null;
}

/**
 * Telemetria operacional. Registra ação, domínio, bytes e código de erro —
 * nunca conteúdo, nome de arquivo, path ou imagem. Falhar aqui jamais
 * interrompe o fluxo do usuário.
 */
export function createTelemetry(client: TypedSupabaseClient, userId: string) {
  return {
    record(input: UsageEventInput): void {
      const payload = {
        user_id: userId,
        event_type: input.eventType,
        action: input.action.slice(0, 80),
        domain: input.domain == null ? null : input.domain.slice(0, 40),
        input_tokens: null,
        output_tokens: null,
        storage_delta_bytes:
          input.eventType === "storage" ? Math.trunc(input.storageDeltaBytes ?? 0) : null,
        error_code: input.errorCode == null ? null : input.errorCode.slice(0, 80),
        request_id: input.requestId ?? null,
        metadata: {},
      };
      void client
        .from("usage_events")
        .insert(payload)
        .then(() => undefined)
        .then(undefined, () => undefined);
    },
  };
}

export type Telemetry = ReturnType<typeof createTelemetry>;
